import React from 'react';
import WatercolorWash from '../WatercolorWash';
import { useReveal } from '../../hooks/useReveal';
import { ABOUT_INTRO, HISTORY, VALUES, VISION } from '../../data/about';
import '../../styles/About.css';

const About: React.FC = () => {
  const { ref, revealed } = useReveal<HTMLElement>();

  return (
    <section
      ref={ref}
      className={`about psl-reveal${revealed ? ' is-in-view' : ''}`}
    >
      <WatercolorWash
        variant="a"
        color="#c68c3b"
        style={{ top: '-60px', left: '-80px' }}
      />

      <div className="about__intro">
        <div className="about__chapter">{ABOUT_INTRO.chapter}</div>
        <p className="about__label">{ABOUT_INTRO.label}</p>
        <h1 className="about__head">
          {ABOUT_INTRO.head.line1}
          <br />
          <em>{ABOUT_INTRO.head.emphasis}</em>
        </h1>
      </div>

      <div className="about__history">
        <div className="about__kicker">{HISTORY.kicker}</div>
        {HISTORY.paragraphs.map((p, i) => (
          <p key={i} className="about__prose">
            {p}
          </p>
        ))}
        <span className="about__margin">{HISTORY.marginNote}</span>
      </div>

      <div className="about__values">
        <div className="about__kicker">{VALUES.kicker}</div>
        <h2 className="about__sub">
          {VALUES.head.line1}{' '}
          <em>{VALUES.head.emphasis}</em>
        </h2>
        <p className="about__prose">{VALUES.body}</p>
        <span className="about__hand">{VALUES.handNote}</span>
      </div>

      <div className="about__vision">
        <div className="about__kicker">{VISION.kicker}</div>
        <h2 className="about__sub about__sub--quote">{VISION.head}</h2>
        <p className="about__prose">{VISION.body}</p>
      </div>
    </section>
  );
};

export default About;
